import { Map } from 'immutable';

import * as AudioPlayerConstants from '../constants/AudioPlayer';

export function browserAutoplayBlockedPattern(action: $TSFixMe): boolean {
  return (
    action.type === AudioPlayerConstants.AudioPlayerActions.ERROR &&
    action.payload.ERROR_OBJ.commonType ===
      AudioPlayerConstants.CommonAudioErrorCodes.BROWSER_AUTOPLAY_BLOCKED
  );
}

export function trackEndErrorUnrecoverablePattern({
  type: actionType,
  payload,
}: $TSFixMe): boolean {
  return (
    actionType === AudioPlayerConstants.AudioPlayerActions.TRACK_END_ERROR && !payload.isRecoverable
  );
}

export function getAudioContentHost(audioUrl: string): string {
  return /pandora\.com|p-cdn\.com|p-cdn\.us|savagebeast\.com/.test(audioUrl)
    ? AudioPlayerConstants.AudioContentHost.INTERNAL
    : AudioPlayerConstants.AudioContentHost.EXTERNAL;
}

export function isTrackEncrypted(track: $TSFixMe): boolean {
  return Map.isMap(track) && !!track.get('key');
}
